import script from "./CartItemRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartItemRow.vue?vue&type=script&setup=true&lang=ts"

import "./CartItemRow.vue?vue&type=style&index=0&id=88bd9c54&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88bd9c54"]])

export default __exports__